export const micrositeDestinationFolder = "microsites";
